import React from "react";
import FilterItem from "../../assets/components/FilterItem";

const TransactionFilters = ({ handleClick, selected }) => {
  return (
    <div className="w-100 mt-1 mb-4 d-flex">
      <FilterItem
        title={"همه"}
        handleClick={() => handleClick("")}
        selected={selected === ""}
      />
      <FilterItem
        title={"واریز"}
        handleClick={() => handleClick("Deposit")}
        selected={selected === "Deposit"}
      />
      <FilterItem
        title={"برداشت"}
        handleClick={() => handleClick("Spend")}
        selected={selected === "Spend"}
      />
    </div>
  );
};

export default TransactionFilters;
